var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.66683H10.833V4.66683C10.833 4.44582 10.7452 4.23385 10.5889 4.07757C10.4326 3.92129 10.2207 3.8335 9.99967 3.8335C9.77866 3.8335 9.5667 3.92129 9.41042 4.07757C9.25414 4.23385 9.16634 4.44582 9.16634 4.66683V9.66683H4.16634C3.94533 9.66683 3.73337 9.75463 3.57709 9.91091C3.42081 10.0672 3.33301 10.2791 3.33301 10.5002C3.33301 10.7212 3.42081 10.9331 3.57709 11.0894C3.73337 11.2457 3.94533 11.3335 4.16634 11.3335H9.16634V16.3335C9.16634 16.5545 9.25414 16.7665 9.41042 16.9228C9.5667 17.079 9.77866 17.1668 9.99967 17.1668C10.2207 17.1668 10.4326 17.079 10.5889 16.9228C10.7452 16.7665 10.833 16.5545 10.833 16.3335V11.3335H15.833C16.054 11.3335 16.266 11.2457 16.4223 11.0894C16.5785 10.9331 16.6663 10.7212 16.6663 10.5002C16.6663 10.2791 16.5785 10.0672 16.4223 9.91091C16.266 9.75463 16.054 9.66683 15.833 9.66683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.eb28ba256b9c63df3cb4e8f233af69f4.svg";
export { ForwardRef as ReactComponent };